import React from 'react';

// components
import { YesNo } from '../components/inputs';
import { FormRow } from '../components/layout';

function PlanTypeConf() {
  return (
    <div>
      <FormRow>
        <YesNo
          label="Plan type confirmation"
          name="planconftype"
        />
      </FormRow>
    </div>
  );
}

export default PlanTypeConf;
